import $ from 'jquery'
import Component from './component'

export class Tabs extends Component {
  constructor(ctx, ev) {
    super(ctx, ev)

    // classes extensions
    Object.assign(this.classes, {
      tabLink: '.js-tabs-link',
      tabItem: '.js-tabs-item',
      tabContent: '.js-tabs-content',
      quantity: '.js-add-product-quantity',
    })

    // classStates extensions
    Object.assign(this.classStates, {
      isCartItemRemove: 'js-cart-item-remove',
    })

    this.bindTabLinks()
  }

  bindTabLinks() {
    // eslint-disable-next-line consistent-return
    this.$ctx.on('click', this.classes.tabLink, (event) => {
      event.preventDefault()

      const $target = $(event.currentTarget)
      const $originalTarget = $(event.target)
      const isInputField =
        $originalTarget.closest(this.classes.quantity).length > 0
      const isCartItemRemove = $originalTarget.hasClass(
        this.classStates.isCartItemRemove
      )

      // ignore when it is cart remove product
      if (isCartItemRemove) {
        return true
      } else if (!isInputField) {
        if ($target.hasClass(this.classStates.active)) {
          this.toggle($target, 'close')
        } else {
          this.toggle($target, 'open')
        }
      }
    })
  }

  toggle($target, action, cb) {
    const $item = $target.closest(this.classes.tabItem)
    const $content = $target.next(this.classes.tabContent)

    if (action === 'open') {
      $content.slideDown(this.durations.tabOpen, () => {
        $target.addClass(this.classStates.active)
        $item.addClass(this.classStates.active)

        if (typeof cb === 'function') {
          cb()
        }
      })
    } else if (action === 'close') {
      $content.slideUp(this.durations.tabClose, () => {
        $target.removeClass(this.classStates.active)
        $item.removeClass(this.classStates.active)

        if (typeof cb === 'function') {
          cb()
        }
      })
    }
  }

  onResize() {
    // noop
  }
}
